<template>
  <el-card shadow="always">
    <div slot="header" class="">
      <div>
        <span>Importar</span>
        <span v-if="typeLabel" class="import-type"> — {{ typeLabel }}</span>
      </div>
      <el-button v-if="type" type="text" icon="el-icon-back" class="import-type" @click="type = ''">Voltar</el-button>
    </div>
    <div>
      <template v-if="!type">
        <p class="import-question">O que você deseja importar?</p>
        <el-row :gutter="15">
          <el-col v-for="option in importTypes" :key="option.value" :xs="24" :sm="12" :md="12" :lg="8" :xl="8">
            <div class="import-tile" @click="type = option.value">
              <i :class="option.icon"></i>
              <span class="import-tile-title">{{ option.label }}</span>
              <p>{{ option.description }}</p>
            </div>
          </el-col>
        </el-row>
      </template>

      <template v-else>
        <ImportPrepostUpload v-if="type === 1" />
        <ImportDelivery v-if="type === 2" />
        <ImportDocs v-if="type === 3" />
        <ImportPrepostAuditUpload v-if="type === 4" />
        <ImportSender2 v-if="type === 5" />
      </template>
    </div>
  </el-card>
</template>

<script>
import ImportDelivery from './ImportDelivery';
import ImportSender2 from './ImportSender2';
import ImportPrepostUpload from './ImportPrepostUpload';
import ImportDocs from './ImportDocs.vue';
import ImportPrepostAuditUpload from './ImportPrepostAuditUpload';
import { UserService } from "@/services/users/user.services";

export default {
  name: 'ImportMainUpload',
  components: {
    ImportPrepostUpload,
    ImportDelivery,
    ImportSender2,
    ImportDocs,
    ImportPrepostAuditUpload,
  },
  data() {
    return {
      type: '',
      userType: undefined
    };
  },

  computed: {
    importTypes() {
      const types = [
        {
          value: 1,
          label: 'Pré-Postagem',
          icon: 'el-icon-box',
          description: 'Crie pré-postagens em lote a partir de planilha ou XML de NF-e',
        },
        {
          value: 2,
          label: 'Destinatário',
          icon: 'el-icon-location-outline',
          description: 'Cadastre destinatários em lote a partir de planilha',
        },
      ];
      if (this.userType === '1') {
        types.push(
          {
            value: 3,
            label: 'Documentos',
            icon: 'el-icon-document',
            description: 'Envie documentos da plataforma, como termos de uso',
          },
          {
            value: 4,
            label: 'Pré-Postagem da Auditoria',
            icon: 'el-icon-s-check',
            description: 'Importe pré-postagens para conferência da auditoria',
          },
          {
            value: 5,
            label: 'Remetente',
            icon: 'el-icon-office-building',
            description: 'Cadastre remetentes em lote a partir de planilha',
          },
        );
      }
      return types;
    },
    typeLabel() {
      const option = this.importTypes.find((item) => item.value === this.type);
      return option ? option.label : '';
    },
  },

  mounted() {
    const vm = this
    UserService.me()
      .then((response) => {
        vm.userType = response.type
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  }
};
</script>

<style scoped>
.import-type {
  color: #909399;
}

.import-question {
  margin-bottom: 20px;
  color: #606266;
}

.import-tile {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 15px;
  min-height: 130px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.import-tile:hover {
  border-color: #409eff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.import-tile i {
  font-size: 26px;
  color: #409eff;
}

.import-tile-title {
  display: block;
  margin-top: 10px;
  font-weight: 600;
  color: #303133;
}

.import-tile p {
  margin: 5px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: #909399;
}
</style>
